import { GetterTree } from 'vuex';
import RootState from '@/store/root_state';
import { BoardsGroupState } from './state';
import { BoardsGroupModel } from '@descomplica/dex-models';

const getters: GetterTree<BoardsGroupState, RootState> = {
  getBoardsGroupsByCourseId: (state, boardsGroupsGetters) => (courseId: number) => {
    const boardsGroups = Object.values(state.boardsGroups).filter(
      (boardsGroup) => boardsGroup.courseId === courseId,
    );
    return boardsGroups.map(
      (boardsGroup) => new BoardsGroupModel(boardsGroup, boardsGroupsGetters),
    );
  },
};

export default getters;
